import {Action} from '../../actions/index';
import {ExcessesActionType, Excesses} from './types';

export interface ExcessesState {
  excesses: Excesses[];
  loadingExcesses: boolean;
  fetchedExcesses: boolean;
}

const initialState: ExcessesState = {
  loadingExcesses: false,
  fetchedExcesses: false,
  excesses: []
};

const excessesReducer = (state: ExcessesState = initialState, action: Action<Excesses[], ExcessesActionType>): ExcessesState => {
  switch (action.type) {
    case ExcessesActionType.FETCH_EXCESSES_LIST_PENDING: {
      return {
        ...state,
        loadingExcesses: true,
        fetchedExcesses: false
      };
    }
    case ExcessesActionType.FETCH_EXCESSES_LIST_FULFILLED: {
      return {
        ...state,
        loadingExcesses: false,
        fetchedExcesses: true,
        excesses: action.payload
      };
    }
    case ExcessesActionType.FETCH_EXCESSES_LIST_REJECTED: {
      return {
        ...state,
        loadingExcesses: false,
        fetchedExcesses: false
      };
    }
    default: {
      return state;
    }
  }
};

export default excessesReducer;
